import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOKEN_KEY = "gr_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.access_token);
  return data.user;
};

export const fetchMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, authHeaders());
  return data;
};

export const fetchMessages = async () => {
  const { data } = await axios.get(`${API}/admin/messages`, authHeaders());
  return data;
};

export const deleteMessage = async (id) => {
  await axios.delete(`${API}/admin/messages/${id}`, authHeaders());
};

export const fetchProjects = async () => {
  const { data } = await axios.get(`${API}/projects`);
  return data;
};

export const createProject = async (payload) => {
  const { data } = await axios.post(`${API}/admin/projects`, payload, authHeaders());
  return data;
};

export const updateProject = async (id, payload) => {
  const { data } = await axios.put(`${API}/admin/projects/${id}`, payload, authHeaders());
  return data;
};

export const deleteProject = async (id) => {
  await axios.delete(`${API}/admin/projects/${id}`, authHeaders());
};

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(detail);
};
